export class InternalTimeSearchParams {
  jobId: number = 0;
  serviceCodeId: number = 0;
  consultantId: number = 0;
  fromDate: Date = null;
  toDate: Date = null;
  showDeleted: boolean = false;
}

